<app-modal-view #modal="modal" modalTitle="Finance vs Invest" class="finance-vs-cash">
  <app-finance-vs-cash-calculator modal-body></app-finance-vs-cash-calculator>
</app-modal-view>
